import { Component, OnInit, OnDestroy } from '@angular/core';

import { EntityValidationErrorResponse, Container, GetSignedUploadURLPayload } from '../../shared/models';

import { ModalService } from '../../shared/modules/modal/modal.service';
import {
  NotificationService, SessionService, UtilsService } from '../../shared/services';
import {
  ClosableModalWithErrorResponseModel
} from '../../shared/components/base/closable-modal-with-error-response-model';

import { TpSafeService } from '../../shared/services/tp-safe.service';

@Component({
  selector: 'add-document-modal',
  templateUrl: './add-document-modal.component.html',
})
export class AddDocumentModalComponent
  extends ClosableModalWithErrorResponseModel<EntityValidationErrorResponse>
  implements OnInit, OnDestroy {

  data: any;
  fileToUpload: File;
  workingContainer: Container;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _sessionService: SessionService,
    private _tpSafeService: TpSafeService,
    private _utilsService: UtilsService,
  ) {
    super(notificationService, modalService);
    this.validationErrors = new EntityValidationErrorResponse();
    this.workingContainer = this._sessionService.getWorkingContainer();
  }

  ngOnInit(): void {
    this.listenForErrorMessages();
  }

  exitModal(): void {
    this.success();
    this.closeAllModals();
  }

  handleFileUpload(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  uploadFileToTPSafe(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    const payload: GetSignedUploadURLPayload = {
      docType: 'localFileReport',
      name: this._utilsService.getFilenameWithoutFileExtension(this.fileToUpload.name),
      entity: this.data.entityId,
      documentType: this._utilsService.getFileExtensionFromFilename(this.fileToUpload.name),
      containerId: this.workingContainer.containerId,
      mimeType: this.fileToUpload.type,
    };

    this._tpSafeService.getSignedUploadURL(payload).subscribe(async (data) => {
      const signedUrl = data.data.url;
      this.uploadFileToS3(signedUrl);
    });
  }

  uploadFileToS3(signedUrl: string) {
    this._tpSafeService.saveFileToTPSafe(signedUrl, this.fileToUpload).subscribe(() => {
      this.exitModal();
    });
  }

}
